import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminConfigs = (args, config) => {
    return useQuery({
        queryKey: ['admin', 'config', 'get', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/configs`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiReadStudentConfigs = (type) => {
    return useQuery({
        queryKey: ['student', 'config', 'read', type],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/configs`, {params: config})
        })({type: type})),
    })
}


export function useApiCreateAdminConfigs() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/configs`, data)
            })(data))
    });
}
